export enum PolicySubmissionType {
    Submission = 'Submission',
    Renewal = 'Renewal',
    Cancellation = 'Cancellation',
    PolicyChange = 'PolicyChange',
    Reinstatement = 'Reinstatement',
    Issuance = 'Issuance'
}